/**
 * @owner @Appboy/reporting
 */

import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isMessageArchivingConsumptionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      app_group: string,
      channel: string,
      messages_archived: number,
      credit_ratio: number,
      credits_used: number,
      last_updated_at: number,
    })
  ),
});
